import Vue from 'vue'

export default Vue.extend({
  template: '<g-data-status loading text="Loading"/>'
})



// WEBPACK FOOTER //
// ./src/pages/mixin/components/DataLoading.js